module.exports = __webpack_public_path__ + "static/media/down.b705ca8a.svg";